module.exports = __webpack_public_path__ + "media/images/become_a_member-289a4b11a7d770051f9e25716fffaf13.png";